import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { Menu, Dropdown } from 'semantic-ui-react';
import SearchInputComponent from '../../search/SearchInputComponent';

export default class DesktopMenu extends Component {

    render() {
        return (
            <Menu fixed="top">
                <Menu.Item>
                    <Dropdown icon="sidebar">
                        <Dropdown.Menu>
                            <Dropdown.Item>
                                <Link to="/">Home</Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link to="/items">Items</Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link to="/appearances">Appearances</Link>
                            </Dropdown.Item>
                            <Dropdown.Item>Recipes</Dropdown.Item>
                            <Dropdown.Item>Quests</Dropdown.Item>
                            <Dropdown.Item>NPCs</Dropdown.Item>
                            <Dropdown.Item>Achievements</Dropdown.Item>
                            <Dropdown.Item>
                                <Link to='/about'>About Us</Link>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Item>
                <Menu.Item position='right'>
                    <SearchInputComponent dropDownPosition='right' fluid={false} />
                </Menu.Item>
            </Menu>
        );
    }
};


// WEBPACK FOOTER //
// ./src/common/menu/MobileMenu.jsx